import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

export default function CompletionByUnitBarChart({ chartId, title, labels, data, height, maxTicksLimit = 20, containerStyle }) {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartId || !Array.isArray(labels) || !Array.isArray(data)) return;
    const ctx = document.getElementById(chartId);
    if (!ctx) return;

    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    chartRef.current = new Chart(ctx.getContext('2d'), {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            label: 'Completion %',
            data,
            backgroundColor: 'rgba(14, 42, 85, 0.6)',
            borderColor: 'rgba(14, 42, 85, 0.9)',
            borderWidth: 1,
            barPercentage: 0.7,
            categoryPercentage: 0.8,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: { display: true, text: 'Unit' },
            ticks: { maxRotation: 45, minRotation: 0, maxTicksLimit: maxTicksLimit ?? undefined },
          },
          y: {
            min: 0,
            max: 100,
            title: { display: true, text: 'Completion %' },
            ticks: { stepSize: 10 },
          },
        },
        plugins: {
          title: { display: true, text: title || 'Completion by unit' },
          legend: { position: 'bottom' },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [chartId, title, labels, data, maxTicksLimit]);

  if (!chartId) return null;
  const h = typeof height === 'number' ? height : 200;
  return (
    <div style={{ width: '100%', maxWidth: '400px', margin: '0 auto', height: h, ...containerStyle }}>
      <canvas id={chartId} width="100%" height={h} />
    </div>
  );
}
